module.exports = __webpack_public_path__ + "static/photo10@2x-b80409144db36497ddb2c101a37fb61c.jpg";